import { SignInMessageWrapper, Wrapper } from './styledComponents';
import { FormattedRichMessage, CoBrandingButton, Link } from 'ciam-self-service-shared';
import { BUTTON_VARIANT, Tooltip } from '@manulife/mux';
import PropTypes from 'prop-types';

function SignInProductLinkWrapper({
  to,
  messageId,
  tooltipContent,
  showTooltip = false,
  analyticsData,
  showRedesignedView = false,
}) {
  return (
    <Wrapper>
      <SignInMessageWrapper
        className={showTooltip ? 'custom-link-wrapper wrapper-with-tooltip' : 'custom-link-wrapper'}
        isTooltip={showTooltip}
        showRedesignedView={showRedesignedView}
      >
        <CoBrandingButton as={Link} to={to} variant={BUTTON_VARIANT.TERTIARY} analyticsData={analyticsData}>
          <FormattedRichMessage id={messageId} />
        </CoBrandingButton>
        {showTooltip && <Tooltip bubbleWidth={200} content={tooltipContent} />}
      </SignInMessageWrapper>
    </Wrapper>
  );
}

SignInProductLinkWrapper.propTypes = {
  to: PropTypes.string.isRequired,
  messageId: PropTypes.string.isRequired,
  tooltipContent: PropTypes.string,
  showTooltip: PropTypes.bool,
  analyticsData: PropTypes.object,
  showRedesignedView: PropTypes.bool,
};

export default SignInProductLinkWrapper;
